import Papa from 'papaparse';
import { TFunction } from 'i18next';
import { ScootersLockHistoryItem } from '../../resources/types/scootersTypes';
import {
  getLockHistoryStatus,
  getLockHistoryStatusLabel
} from '../../components/ScootersLockHistoryTable/lockHistoryStatus';

// Час в експорті завжди в часовому поясі парку (Іспанія), а не в локальному
// поясі того, хто вивантажує. en-GB дає саме CET/CEST і сам враховує літній час.
export const EXPORT_TIME_ZONE = 'Europe/Madrid';

const exportTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: EXPORT_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
  timeZoneName: 'short'
});

export const formatExportTime = (date?: string | null) => {
  if (!date) return { dateTime: '', zone: '' };

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return { dateTime: '', zone: '' };

  const parts = exportTimeFormatter.formatToParts(parsed);
  const get = (type: string) =>
    parts.find(part => part.type === type)?.value ?? '';

  return {
    dateTime: `${get('day')}.${get('month')}.${get('year')} ${get('hour')}:${get(
      'minute'
    )}:${get('second')}`,
    zone: get('timeZoneName')
  };
};

// Дата для назви файлу - теж у поясі парку, щоб не з'їжджала біля опівночі
export const getExportDateStamp = () => {
  const parts = exportTimeFormatter.formatToParts(new Date());
  const get = (type: string) =>
    parts.find(part => part.type === type)?.value ?? '';

  return `${get('year')}-${get('month')}-${get('day')}`;
};

export const buildLockHistoryCsv = (
  rows: ScootersLockHistoryItem[],
  t: TFunction
) => {
  const data = rows.map(row => {
    const time = formatExportTime(row.createdAt);

    return {
      [t('lockHistory.csvColTime')]: time.dateTime,
      [t('lockHistory.csvColTimeZone')]: time.zone,
      [t('lockHistory.colScooter')]: row.scooterId?.name ?? '',
      [t('lockHistory.csvAction')]: row.lock
        ? t('lockHistory.csvActionLock')
        : t('lockHistory.csvActionUnlock'),
      [t('lockHistory.colStatus')]: getLockHistoryStatusLabel(
        getLockHistoryStatus(row),
        t
      ),
      [t('lockHistory.colUser')]: row.adminId?.login ?? '',
      [t('lockHistory.csvType')]: row.type ?? ''
    };
  });

  // BOM, щоб Excel коректно читав кирилицю
  return '﻿' + Papa.unparse(data, { quotes: true });
};

export const downloadCsv = (csv: string, fileName: string) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
